import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {NGXLogger} from 'ngx-logger';
import {
    ColumnFilter,
    DataTableColumnData,
    DataTableConfig,
    DataTableDataSource,
    DataTableLazyLoadDataSource,
    DataTableLazyLoadRefresher,
    DataTableObservableCompletionListener,
    DataTableObservableErrorListener,
    DatatableComponent,
    TableAction, PaginatedResponse,
} from '@cas-hub/acabim-common-client';

import {SiteGroup} from '../../../../_models/group.model';
import {GroupService} from '../../../../_services/group.service';
import {map, tap} from 'rxjs/operators';
import {DatePipe} from '@angular/common';

@Component({
    selector: 'acabim-admin-groups-sites',
    templateUrl: './groups-sites.component.html'
})
export class GroupSiteComponent implements OnInit {

    public addSiteGroupModal = false;
    public editSiteGroupModal = false;

    @ViewChild('dataTable') public dataTable!: DatatableComponent;

    public dataSources: DataTableDataSource<any>[] = [];

    constructor(
        public readonly router: Router,
        private readonly logger: NGXLogger,
        protected readonly datePipe: DatePipe,
        private readonly groupService: GroupService
    ) {
    }

    ngOnInit(): void {
        this.dataSources.push(
            new SiteGroupDataSource(
                (first, length, sortOrder, sortField, filters) => {
                    return this.groupService.getSiteGroups(first, length, sortOrder, sortField, filters)
                        .pipe(map(item => item as PaginatedResponse<SiteGroup>), map(data => ({
                        totalRecords: data.totalRecords,
                        data: data.data
                    })), tap(data => {
                            data.data.forEach(group => {
                                const newDate = new Date(group.lastModifiedDate);
                                group.lastModifiedDate = (this.datePipe.transform(newDate, 'dd MMMM yyyy') as string);
                            });
                        }));
                },
                (tableName: string, error: Error) => {
                    this.logger.debug('[GroupSiteComponent] Error in retrieving data in table ' + tableName);
                    this.logger.error(error);
                },
                (tableName: string) => {
                    this.logger.debug('[GroupSiteComponent] Completed retrieving data in table ' + tableName);
                }, (action: TableAction) => {
                    if (action.id === 0) {
                        this.logger.debug('[GroupSiteComponent] At action 0');
                    } else if (action.id === 1) {
                        this.logger.debug('[GroupSiteComponent] At action 1');
                    }
                }
            )
        );
    }

    // ADD
    setAddSiteGroupModal(value: boolean): void {
        this.addSiteGroupModal = value;
    }

    onAddSiteGroup(): void {
        this.addSiteGroupModal = true;
    }

    onAddCompletion(completed: string) {
        this.addSiteGroupModal = false;
        if (completed === 'added') {
            this.setAddSiteGroupModal(false);
            this.dataTable?.requestImmediateDataRefresh();
        } else if (completed === 'cancelled') {
            this.setAddSiteGroupModal(false);
        }
    }

    // EDIT
    setEditSiteGroupModal(value: boolean): void {
        this.editSiteGroupModal = value;
        this.dataSources[0].showDetails = value;
    }

    onEditCompletion(completed: string) {
        console.log(completed);
        this.editSiteGroupModal = false;
        if (completed === 'updated') {
            this.setEditSiteGroupModal(false);
            this.dataTable?.requestImmediateDataRefresh();
        } else if (completed === 'cancelled') {
            this.setEditSiteGroupModal(false);
        }
    }

} // end of component

export class SiteGroupDataSource extends DataTableLazyLoadDataSource<SiteGroup> {

    readonly columnData: DataTableColumnData[] =
        [
            {displayName: 'Name', objectPropertyName: 'name'},
            {displayName: 'Last Modified', objectPropertyName: 'lastModifiedDate', type: 'date'}
        ];

    readonly config: DataTableConfig = {
        tableHeading: '',
        isSearchEnabled: false,
        searchPlaceHolder: 'Search site-and-project groups',
        emptyMessage: '',
        globalFilterFields: [],
        hasCheckbox: false,
        hasDetailsButton: true,
        isLazyLoadingEnabled: true,
        isPaginationEnabled: true,
        hasFilters: true,
        isExportEnabled: false,
        hasActions: true
    };

    readonly columnFilters: ColumnFilter[] = [];

    readonly actions: TableAction[] = [{name: 'Archive', id: 0}, {name: 'Group', id: 1}];

    onDataExpanded(value: SiteGroup): void {
    }

    constructor(readonly refresher: DataTableLazyLoadRefresher<SiteGroup>,
                readonly observableErrorListener?: DataTableObservableErrorListener,
                readonly observableCompleteListener?: DataTableObservableCompletionListener,
                readonly actionListener?: (action: TableAction) => void) {
        super(refresher, observableErrorListener, observableCompleteListener);
    }

    onAction(action: TableAction): void {
        if (this.actionListener) {
            this.actionListener(action);
        }
    }
}
